import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const DELETE_CASE_CODE = "DELETE_CASE_CODE";

export const service = async (eaCaseCodeId) => {
  const options: object = {
    url: "/api/EaCaseApiController/DeleteCode/" + eaCaseCodeId,
    method: "POST",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(DELETE_CASE_CODE, service, mock);
